import styled from "styled-components";

export const Trilha = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;

  #div-pather {
    width: 100vw;
    max-width: 1300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 43px;

    #div-one {
      display: flex;
      flex-direction: column;

      h1 {
        font-weight: 700;
        font-size: 30px;
        line-height: 140%;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        line-height: 160%;
      }

      a {
        height: 56px;
        width: 100%;
        max-width: 320px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: var(--blue);
        color: var(--white);
        margin: 25px auto;

        :visited {
          color: var(--white);
        }
      }
    }

    #div-two {
      margin: 25px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      figure {
        width: 90%;

        img {
          width: 100%;
        }
      }
    }
  }

  @media (min-width: 701px) {
    #div-pather {
      flex-direction: row;

      #div-one {
        width: 50%;

        h1 {
          font-size: 48px;
        }

        p {
          font-size: 17px;
          width: 80%;
        }

        a {
          margin: 25px 0;
        }
      }

      #div-two {
        width: 50%;

        figure {
          width: 100%;
        }
      }
    }
  }
`;
